import bearImg from '~/assets/image/profile/profile_bear.png'
import catImg from '~/assets/image/profile/profile_cat.png'
import chickImg from '~/assets/image/profile/profile_chick.png'
import cockImg from '~/assets/image/profile/profile_cock.png'
import cowImg from '~/assets/image/profile/profile_cow.png'
import elephantImg from '~/assets/image/profile/profile_elephant.png'
import pigImg from '~/assets/image/profile/profile_pig.png'
import rabbitImg from '~/assets/image/profile/profile_rabbit.png'
import sheepImg from '~/assets/image/profile/profile_sheep.png'
import tigerImg from '~/assets/image/profile/profile_tiger.png'

const profileImages = [
  {name: 'chick', img: chickImg},
  {name: 'bear', img: bearImg},
  {name: 'pig', img: pigImg},
  {name: 'elephant', img: elephantImg},
  {name: 'cat', img: catImg},
  {name: 'sheep', img: sheepImg},
  {name: 'rabbit', img: rabbitImg},
  {name: 'cock', img: cockImg},
  {name: 'cow', img: cowImg},
  {name: 'tiger', img: tigerImg}
]

export const profileArr = {
  chick: chickImg,
  bear: bearImg,
  pig: pigImg,
  elephant: elephantImg,
  cat: catImg,
  sheep: sheepImg,
  rabbit: rabbitImg,
  cock: cockImg,
  cow: cowImg,
  tiger: tigerImg
}

export default profileImages
